<template>
  <section id="simulator-notary" class="simulator">
    <div class="simulator__container">
      <div class="simulator__form">
        <div class="simulator__item required">
          <label for="departments">Votre département *</label>
          <select name="departments" id="departments" v-model="department">
            <option value="">Sélectionnez un département</option>
            <option v-for="department in departmentsOptions" :value="department.code">
              <span>{{ department.code }} - {{ department.nom }}</span>
            </option>
          </select>
        </div>
        <div class="simulator__item required">
          <label for="nbLodgings">Nombre de lots dans le programme *</label>
          <select name="nbLodgings" id="nbLodgings" v-model="nbLodgings">
            <option value="">Sélectionnez le nombre de lots</option>
            <option v-for="nbLodging in nbLodgingsOptions" :value="nbLodging.slug">
              <span>{{ nbLodging.label }}</span>
            </option>
          </select>
        </div>
        <div class="simulator__item required">
          <label for="price">Prix d'achat *</label>
          <input id="price" type="number" placeholder="en euros" v-model.number="price" @keyup.enter="calc">
          <span class="description">Hors frais de négociation ou d'agence</span>
        </div>
        <ul v-if="errors.length" class="callout callout--error">
          <li v-for="error in errors">{{ error }}</li>
        </ul>
        <div class="simulator__actions">
          <button class="button" @click="calc">
            <span>Calculer</span>
          </button>
          <button class="link" @click="reset">
            <span class="link__txt">Réinitialiser</span>
          </button>
        </div>
      </div>

      <div id="costs" class="simulator-result" v-if="costs">
        <span class="simulator-result__title">Vos frais (arrondis)</span>
        <span class="simulator-result__money">{{ costs }}</span>
        <div class="simulator-result__legals">
          <p>Cette simulation est donnée à titre indicatif et n'a pas de valeur contractuelle.</p>
        </div>
      </div>

      <div class="simulator__legals">
        <span>* Ces champs sont obligatoires</span>
      </div>
    </div>
  </section>
</template >

<script>

  export default {
    name: "SimulatorNotary",
    data() {
      return {
        departmentsOptions: fetch('https://geo.api.gouv.fr/departements')
          .then(response => response.text())
          .then(result => {
            this.departmentsOptions = JSON.parse(result);
          }),
        nbLodgingsOptions: [
          {'slug': 'OneTo10',           'label': '1 à 10'},
          {'slug': 'ElevenTo24',        'label': '11 à 24'},
          {'slug': 'TwentyFiveTo99',    'label': '25 à 99'},
          {'slug': 'OneHundredTo249',   'label': '100 à 249'},
          {'slug': 'TwoFiftyTo499',     'label': '250 à 499'},
          {'slug': 'FiveHundredOrMore', 'label': '500 et plus'}
        ],
        department: '',
        nbLodgings: '',
        price: '',
        costs: '',
        isResultVisible: false,
        errors: []
      };
    },
    methods: {
      calc: function () {

        this.errors = [];
        this.isResultVisible = false;

        if ( ! this.areFieldsFilled() )
          return;

        fetch('https://www.immobilier.notaires.fr/pub-services/inotr-www-calculs/v1/frais-acquisition?categorieBien=NEUF&codeInsee=' + this.department + '&nombreLogement=' + this.nbLodgings + '&prixAcquisition=' + this.price)
        .then(response => response.text())
        .then(result => {

          this.isResultVisible = true;

          result = JSON.parse(result);
          this.costs = Math.round(result['totalFrais']).toLocaleString('fr-FR') + '€';
        })
        .catch(error => console.log('error', error));

      },
      reset: function () {
        this.department = '';
        this.nbLodgings = '';
        this.price = '';
        this.costs = '';
        this.isResultVisible = false;
        this.errors = [];
      },
      areFieldsFilled: function () {

        if (this.department && this.nbLodgings && this.price)
          return true;

        if (!this.department)
          this.errors.push('Veuillez sélectionenr un département.');
        if (!this.nbLodgings)
          this.errors.push('Veuillez saisir le nombre de lots dans le programme .');
        if (!this.price)
          this.errors.push('Veuillez saisir le prix d\'achat.');

        return false;

      }
    }

  };
</script>

